export function Tickers() {
    var $blocks = $(".marquee");
    $blocks.each(function () {
        Ticker($(this));
    });
}
function Ticker(block) {
    const WIN = $(window);
    const $marquee = block;
    const $marqueContent = $marquee.children();
    $marqueContent.text($marqueContent.text() + "\u00A0");
    let widthMarquee;
    const spead = 15;
    let time = null;
    createMarqueeBlock();
    setTimeout(() => {
        getData();
        setStyles();
    }, 0)

    WIN.on("resize", function () {
        getData();
        setStyles();
    });
    function createMarqueeBlock() {
        $marquee.wrapInner("<span class='marquee-text'>");
        $marquee.append($marquee.find(".marquee-text").clone());
        $marquee.wrapInner("<div class='marquee-block'>");

    }
    function getData() {
        widthMarquee = $marqueContent.width();
        const windowWidth = WIN.width();
        checkMarquee(windowWidth)
        widthMarquee = $marqueContent.width();
        time = spead * widthMarquee / windowWidth;
    }
    function checkMarquee(w_w) {
        if (w_w > widthMarquee) {
            let text = $marqueContent.text()
            $marqueContent.text(text + text);
            widthMarquee = $marqueContent.width();
            checkMarquee(w_w)
        }
    }
    function setStyles() {
        const content = $marquee.find(".marquee-text").html()
        $marquee.find(".marquee-text").last().html(content)
        $marquee.find(".marquee-text").css({ "width": `${widthMarquee}`, "display": "inline-block" });
        $marquee.find(".marquee-block").css({ "width": `${widthMarquee * 2}px`, 'animation-duration': `${time}s` });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/Tickers.js